module.exports = __webpack_public_path__ + "payment-methods.ea00063358375d8f6eb2.png";


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/assets/images/payment-methods.png
// module id = ../../../../../src/assets/images/payment-methods.png
// module chunks = styles